// src/utils/pixelEvents.js

// Track when a user views the packages page
export const trackViewPackages = () => {
    if (window.fbq) {
      window.fbq('track', 'ViewContent', {
        content_type: 'product_group',
        content_name: 'Song Packages'
      });
    }
  };
  
  // Track when a user selects a package
  export const trackSelectPackage = (packageType, price) => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_type: 'product',
        content_name: packageType,
        value: price,
        currency: 'USD'
      });
    }
  };
  
  // Track when a user initiates checkout
  export const trackInitiateCheckout = (total) => {
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        value: total,
        currency: 'USD'
      });
    }
  };
  
  // Track when a purchase is completed
  export const trackPurchase = (orderId, total) => {
    if (window.fbq) {
      window.fbq('track', 'Purchase', {
        value: total,
        currency: 'USD',
        content_type: 'product',
        order_id: orderId
      });
    }
  };